import request from '@/request/request';
import { tansParams } from "@/utils/src/tansParams";

// 获取设备code
export function getEquipmentCode(key) {
    return request({
        url: '/api/system-server/sysConfig/getByConfigKey?configKey=' + key,
        method: 'get'
    })
}

// 查询设备列表
export function listEquipment(query) {
    return request({
        url: `/api/equipment-server/equipment/list`,
        method: 'get',
        params: query
    })
}

// 查询设备详细
export function getEquipmentById(id) {
    return request({
        url: '/api/equipment-server/equipment/' + id,
        method: 'get'
    })
}

// 新增设备
export function addEquipment(data) {
    return request({
        url: '/api/equipment-server/equipment/add',
        method: 'post',
        data: data
    })
}

// 修改设备
export function updateEquipment(data) {
    return request({
        url: '/api/equipment-server/equipment/edit',
        method: 'post',
        data: data
    })
}

// 删除设备
export function delEquipment(data) {
    return request({
        url: '/api/equipment-server/equipment/delete/' + data.id,
        method: 'post'
    })
}

// 查询设备分类列表
export function listEquipmentCategory(query) {
    return request({
        url: '/api/equipment-server/equipmentCategory/list',
        method: 'get',
        params: query
    })
}

// 有设备的区域
export function listEquipmentArea(query) {
    return request({
        url: '/api/equipment-server/equipment/listArea',
        method: 'get',
        params: query
    })
}

// 按小时聚合查询客流统计
export function listPassengerFlowHour(query) {
    return request({
        url: '/api/equipment-server/passengerFlowStat/aggregationHour',
        method: 'get',
        params: query
    })
}

// 查询客流统计列表
export function listPassengerFlow(query) {
    return request({
        url: '/api/equipment-server/passengerFlowStat/list',
        method: 'get',
        params: query
    })
}
// 查询客流累计统计列表
export function listTodayTotalPassengerFlow(query) {
    return request({
        url: '/api/equipment-server/passengerFlowStat/list-today-total',
        method: 'get',
        params: query
    })
}
//查询今日客流
export function getSumDay(params) {
    return request({
        url: '/api/equipment-server/passengerFlowStat/sumDay',
        method: 'get',
        params
    })
}
//按区域查询客流
export function sumToDayByArea(params) {
    return request({
        url: '/api/equipment-server/passengerFlowStat/sumToDayByArea',
        method: 'get',
        params
    })
}
// 智能控制
export function controlDevice(data) {
    return request({
        url: '/api/equipment-server/equipment/controlDevice',
        method: 'post',
        data: data
    })
}

//按天聚合查询智能设备数据分析
export function listAggregationDay(data) {
    return request({
        url: '/api/equipment-server/equipmentDataStat/aggregationDay',
        method: 'post',
        data: data
    })
}

// 按设备聚合查询
export function listPassengerFlowEquipment(query) {
    return request({
        url: '/api/equipment-server/passengerFlowStat/aggregationEquipment',
        method: 'get',
        params: query
    })
}

// 获取轮播列表
export function getCarouselList(query) {
    return request({
        url: '/api/equipment-server/integratedCarousel/list',
        method: 'get',
        params: query
    })
}

// 新建轮播
export function addIntegratedCarousel(data) {
    return request({
        url: '/api/equipment-server/integratedCarousel',
        method: 'post',
        data: data
    })
}

// 修改轮播
export function editIntegratedCarousel(data) {
    return request({
        url: '/api/equipment-server/integratedCarousel/edit',
        method: 'post',
        data: data
    })
}

// 删除轮播
export function deleteIntegratedCarousel(id) {
    return request({
        url: '/api/equipment-server/integratedCarousel/delete/' + id,
        method: 'post'
    })
}
//同步摄像头设备
export function monitorTong(query) {
    return request({
        url: '/api/device/query/devices/41162600002000000111/sync',
        method: 'get',
        params: query
    })
}
// 同步广播设备的接口
export function tongEquipment() {
    return request({
        url: '/api/equipment-server/equipment/syncBroadcast',
        method: 'get'
    })
}
// 单个摄像头车流实时数据接口
export function getCarflow(id) {
    return request({
        url: '/api/equipment-server/dw-detail/equipment/carflow?id=' + id,
        method: 'get'
    })
}
// 单个摄像头车流实时数据接口
export function getCarflowByCode(code) {
    return request({
        url: '/api/equipment-server/dw-detail/equipment/carflow?equipmentCode=' + code,
        method: 'get'
    })
}
//客流热力图接口
export function getHeatWholeData(params) {
    return request({
        url: '/api/equipment-server/dw-detail/heat/whole-data',
        method: 'get',
        params
    })
}
//车流热力图接口
export function getHeatVechicleData(params) {
    return request({
        url: '/api/equipment-server/dw-detail/heat/vechicle-data',
        method: 'get',
        params
    })
}
//wifi设备同步接口
export function getWifiDatasync(params) {
    return request({
        url: '/api/equipment-server/equipment/syncWifi',
        method: 'get',
        params
    })
}